/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Settings_ActiveInputs */

const en_task_settings_active = /** @type {(inputs: Task_Settings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

const pt_br2_task_settings_active = /** @type {(inputs: Task_Settings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativa`)
};

/**
* | output |
* | --- |
* | "Active" |
*
* @param {Task_Settings_ActiveInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_settings_active = /** @type {((inputs?: Task_Settings_ActiveInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Settings_ActiveInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_settings_active(inputs)
	return pt_br2_task_settings_active(inputs)
});